/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateExerciseFactDTO
 */
export interface CreateExerciseFactDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateExerciseFactDTO
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateExerciseFactDTO
     */
    description: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateExerciseFactDTO
     */
    glossaryIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateExerciseFactDTO
     */
    exerciseId?: string;
}

/**
 * Check if a given object implements the CreateExerciseFactDTO interface.
 */
export function instanceOfCreateExerciseFactDTO(value: object): value is CreateExerciseFactDTO {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function CreateExerciseFactDTOFromJSON(json: any): CreateExerciseFactDTO {
    return CreateExerciseFactDTOFromJSONTyped(json, false);
}

export function CreateExerciseFactDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateExerciseFactDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'],
        'glossaryIds': json['glossaryIds'] == null ? undefined : json['glossaryIds'],
        'exerciseId': json['exerciseId'] == null ? undefined : json['exerciseId'],
    };
}

export function CreateExerciseFactDTOToJSON(json: any): CreateExerciseFactDTO {
    return CreateExerciseFactDTOToJSONTyped(json, false);
}

export function CreateExerciseFactDTOToJSONTyped(value?: CreateExerciseFactDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'glossaryIds': value['glossaryIds'],
        'exerciseId': value['exerciseId'],
    };
}

